import { Keyword, List } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
/**
 * @internal
 */
export const parse = Keyword.parse("fixed", "local", "scroll");
const parseList = List.parseCommaSeparated(parse);
/**
 * @internal
 */
export const initialItem = Keyword.of("scroll");
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-attachment}
 * @internal
 */
export default Longhand.of(List.of([initialItem], ", "), parseList, (value) => value);
//# sourceMappingURL=background-attachment.js.map